import { z } from 'zod'

export const ADMINDESKTOPAGENTSPOSTGRANTS_CONTRACT_VERSION = '1.0.0' as const
export const adminDesktopAgentsPostGrantsResponseSchema = z.unknown()
export type AdminDesktopAgentsPostGrantsResponse = z.infer<typeof adminDesktopAgentsPostGrantsResponseSchema>
